import { useEffect, useRef } from 'react';
import { useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import BTBox from '../../common/components/BTBox';
import { termsText } from '../../common/data/TermsData';
import { dynamicTranslator } from '../../common/utils/DynamicTranslator';
import i18n from '../../common/i18n/i18n';

const TermsSection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 컴포넌트 마운트 후 번역 적용
    const timer = setTimeout(() => {
      if (contentRef.current) {
        dynamicTranslator.translatePage(contentRef.current);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // 언어 변경 시 재번역
    const handleLanguageChange = () => {
      setTimeout(() => {
        if (contentRef.current) {
          dynamicTranslator.translatePage(contentRef.current);
        }
      }, 100);
    };

    i18n.on('languageChanged', handleLanguageChange);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const termsContent = () => {
    return (
      <div 
        ref={contentRef}
        style={{ color: 'black' }} 
        dangerouslySetInnerHTML={{ __html: termsText }} 
      />
    );
  };

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white', width: '100%', }}>
      {termsContent()}
      <BTBox height={200} />
    </VerticalLayout>
  );
};

export default TermsSection2;
